import { render, staticRenderFns } from "./SelectedTagCategory.vue?vue&type=template&id=345e87b8&"
import script from "./SelectedTagCategory.vue?vue&type=script&lang=ts&"
export * from "./SelectedTagCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports